<template>
<div class="sidebar-popup">
  <transition name="opacity">
    <!-- wrapper is only needed for transitions. -->
    <div :key="category.id" class="sidebar-popup__content-wrapper">
      <div class="sidebar-popup__header-and-close-button">
        <h3 class="sidebar-popup__header">
          <router-link
            :to="getCategoryRoute(category)"
          >{{ category.name }}</router-link>
        </h3>
        <button
          @click="$emit('close')"
          type="button"
          aria-label="Закрыть"
          class="sidebar-popup__close-button"
        >
          <IconCross/>
        </button>
      </div>
      <ul>
        <PopupCategory
          v-for="c of category.children"
          :key="c.id"
          :category="c"
        />
      </ul>
    </div>
  </transition>
</div>
</template>

<script>
import getCategoryRoute from './getCategoryRoute';
import PopupCategory from './categories/PopupCategory';

export default {
  components: {
    PopupCategory,
    IconCross: () => import(/* webpackPreload: true */ '@/assets/images/icons/icon-cross.svg?inline'),
  },
  props: {
    category: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getCategoryRoute,
  },
}
</script>

<style lang="less">
.sidebar-popup {
  @apply bg-secondary-lightest
    overflow-y-auto; // Replace with Simplebar?
  width: calc(theme('width.64') + theme('width.20'));
  // Not `var(--sidebar-width)` because it's `0` when it's folded by default. We mean its unfolded width.
  max-width: calc(100vw - theme('customVars.sidebar.width'));
  &__content-wrapper {
    @apply px-6 py-1;
    &.opacity-leave-active {
      @apply absolute
        w-full; // So it doesn't jump.
    }
  }
  &__header-and-close-button {
    @apply flex justify-between items-center;
  }
  &__header {
    @apply text-xl my-4;
    > a {
      &:focus, &:hover, &.router-link-active {
        @apply text-primary outline-none;
      }
    }
  }
  &__close-button {
    @apply w-4;
    svg {
      @apply fill-current;
    }
  }
}
</style>
